import React, { useContext, useEffect } from 'react'
import { authContext } from '../Login/AuthContext';
import "../conf.js"
import "./config.js"
import VentilationTotalTypes from './Ventilation/VentilationTotal.js'
import VentilationTypes from './Ventilation/VentilationTypes.js'
import AreasTable from './Areas/AreasTable'

/*  eslint eqeqeq: 0 */

const Ventilation = () => {
  const { auth } = useContext(authContext);

  useEffect(() => {}, [auth.data])

  return (
      <div className="layout">
        <h1 id="areas">Ventilation des commentaires sur Booking</h1>
        <AreasTable/>
        <VentilationTotalTypes/>
        <VentilationTypes/>
        <div className="xl-container" id="rep0"></div>
        <div className="xl-container" id="rep1"></div>
        <div className="xl-container" id="rep2"></div>
        <div className="xl-container" id="rep3"></div>
        <div className="xl-container" id="rep4"></div>
        <div className="xl-container" id="rep5"></div>
      </div>
  )
}

export default Ventilation;
